import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/** Shared by both apps (main.tsx, control.tsx). */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Retry transient failures only; a 4xx will not fix itself.
        retry: (count, err) => count < 2 && !(err instanceof ApiError && err.status >= 400 && err.status < 500),
        refetchOnWindowFocus: false,
      },
    },
  });
}
